import httpService from './httpService';

export default {
  query,
  remove,
  add,
  update,
};
function query(filterBy) {
  let filters = [];
  for (let filterKey in filterBy) {
    const value = filterBy[filterKey];
    if (value !== null && value !== undefined)
      filters.push(filterKey + '=' + value);
  }
  let filterUrlParams = filters.length ? '?' + filters.join('&') : '';
  return httpService.get(`shop${filterUrlParams}`);
}

function remove(shopId) {
  return httpService.delete(`shop/${shopId}`);
}
function add(shop) {
  return httpService.post(`shop`, shop);
}

function update(shop) {
  return httpService.put(`shop/${shop._id}`, shop);
}
